module.exports = __webpack_public_path__ + "img/value2.a14b7187.webp";